import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Button } from '$partials/ui';
import { useLanguage } from '$contexts/language.jsx';
import { StaticTitle } from '$partials/layout/side-titles.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ContactGlobal = ({
    facebook      = null,
    instagram     = null,
    linkedin      = null,
    mailingListId = null,
    sideTitle     = null,
    title         = null,
    twitter       = null,
    wechat        = null,
    weibo         = null,
    youtube       = null,
}) => {
    // hooks
    const { translate: t } = useLanguage();

    const {
        formState: { errors },
        handleSubmit,
        register
    } = useForm({
        shouldFocusError: true,
        shouldUnregister: true
    });

    // state
    const [ submitResponse, setSubmitResponse ] = useState();

    // methods
    const handleSubmitInternal = async (data) => {
        try {
            //
        } catch (err) {
            //
        }
    };

    // render
    return (
        <section className='module-contact-global'>
            <div className='pr-gutter mxn-gutter'>  {/* outer grid gutter */}
                <div className='flex flex-wrap mb7 sm-mb7 md-mb9'>
                    {/* side title */}
                    <div className='absolute md-relative md-col-2'>
                        {(title && sideTitle) && (
                            <div className='px-gutter'>
                                <p className='type-style-5 side-title'>
                                    <StaticTitle title={sideTitle} />
                                </p>
                            </div>
                        )}
                    </div>

                    {/* content / title */}
                    <div className='col-11 sm-col-8 md-col-7'>
                        <div className='ml9 sm-ml9 md-m0'>
                            <div className='px-gutter'>
                                <div
                                    className='rich-text type-style-1'
                                    dangerouslySetInnerHTML={{ __html: title }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* content */}
            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                <div className='flex flex-wrap'>
                    {/* side title */}
                    <div className='absolute md-relative md-col-2'>
                        {(!title && sideTitle) && (
                            <div className='px-gutter'>
                                <p className='type-style-5 side-title side-title--no-top'>
                                    <StaticTitle title={sideTitle} />
                                </p>
                            </div>
                        )}
                    </div>

                    {/* content */}
                    <div className='col-12 md-col-10'>
                        <div className='ml9 sm-ml9 md-m0'>
                            <div className='flex flex-wrap'>
                                {/* hide until client has mail service to use */}
                                {false && (
                                    <div className='col-12 sm-col-6 md-col-6'>
                                        <div className='px-gutter'>
                                            <h3 className='type-style-3 pb3 border-bottom border-black capitalise'>
                                                {t('Subscribe to our Newsletter')}
                                            </h3>

                                            <form
                                                action='/api/newsletter/v1/signup'
                                                method='post'
                                                onSubmit={handleSubmit(handleSubmitInternal)}>

                                                {/* name */}
                                                <div className='flex items-center justify-between border-bottom border-black'>
                                                    <label
                                                        className='accessible-hide type-style-6 capitalise'
                                                        htmlFor='frm-name'>
                                                        {t('Name')}
                                                    </label>
                                                    <input
                                                        {...register('name', { required: 'Please enter your name.' })}
                                                        isRequired
                                                        className='form-field-reset width-100 pb3 pt4 type-style-6'
                                                        id='frm-name'
                                                        label='name'
                                                        maxLength={100}
                                                        placeholder='Enter your name'
                                                        type='text' />
                                                </div>

                                                {/* email */}
                                                <div className='flex items-center justify-between border-bottom border-black'>
                                                    <label
                                                        className='accessible-hide type-style-6 capitalise'
                                                        htmlFor='frm-email'>
                                                        {t('Email')}
                                                    </label>
                                                    <input
                                                        {...register('email', { required: 'Please enter your email.' })}
                                                        isRequired
                                                        className='form-field-reset width-100 pb3 pt4 type-style-6'
                                                        id='frm-email'
                                                        label='Email'
                                                        maxLength={100}
                                                        placeholder='... and your email'
                                                        type='email' />
                                                </div>

                                                {/* submit */}
                                                <div className='mt5'>
                                                    <Button
                                                        className='button'
                                                        type='submit'>
                                                        <span className='capitalise'>
                                                            {t('Subscribe')}
                                                        </span>
                                                    </Button>
                                                </div>

                                                {/* errors */}
                                                <div className='type-style-6 italic red-orange mt5'>
                                                    {errors?.name?.message && (
                                                        <p>
                                                            {errors.name.message}
                                                        </p>
                                                    )}

                                                    {errors?.email?.message && (
                                                        <p>
                                                            {errors.email.message}
                                                        </p>
                                                    )}
                                                </div>
                                            </form>

                                            {/* submit response */}
                                            {submitResponse && (
                                                <div
                                                    className='rich-text my5'
                                                    dangerouslySetInnerHTML={{ __html: submitResponse }} />
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className='col-12 sm-col-6 md-col-6 mt7 sm-mt0 md-mt0'>
                                    <div className='px-gutter'>
                                        <h3 className='type-style-3 pb3 border-bottom border-black capitalise'>
                                            {t('Follow Us')}:
                                        </h3>

                                        <ul className='list-reset'>
                                            {facebook && (
                                                <li className='border-bottom border-black'>
                                                    <a
                                                        className='link-reset block mb3 mt4 type-style-6 hans-purple'
                                                        href={facebook}
                                                        rel='noreferrer noopener'
                                                        target='_blank'>
                                                        Facebook
                                                    </a>
                                                </li>
                                            )}

                                            {instagram && (
                                                <li className='border-bottom border-black'>
                                                    <a
                                                        className='link-reset block mb3 mt4 type-style-6 hans-purple'
                                                        href={instagram}
                                                        rel='noreferrer noopener'
                                                        target='_blank'>
                                                        Instagram
                                                    </a>
                                                </li>
                                            )}

                                            {linkedin && (
                                                <li className='border-bottom border-black'>
                                                    <a
                                                        className='link-reset block mb3 mt4 type-style-6 hans-purple'
                                                        href={linkedin}
                                                        rel='noreferrer noopener'
                                                        target='_blank'>
                                                        LinkedIn
                                                    </a>
                                                </li>
                                            )}

                                            {twitter && (
                                                <li className='border-bottom border-black'>
                                                    <a
                                                        className='link-reset block mb3 mt4 type-style-6 hans-purple'
                                                        href={twitter}
                                                        rel='noreferrer noopener'
                                                        target='_blank'>
                                                        Twitter
                                                    </a>
                                                </li>
                                            )}

                                            {wechat && (
                                                <li className='border-bottom border-black'>
                                                    <a
                                                        className='link-reset block mb3 mt4 type-style-6 hans-purple'
                                                        href={wechat}
                                                        rel='noreferrer noopener'
                                                        target='_blank'>
                                                        WeChat
                                                    </a>
                                                </li>
                                            )}

                                            {weibo && (
                                                <li className='border-bottom border-black'>
                                                    <a
                                                        className='link-reset block mb3 mt4 type-style-6 hans-purple'
                                                        href={weibo}
                                                        rel='noreferrer noopener'
                                                        target='_blank'>
                                                        Weibo
                                                    </a>
                                                </li>
                                            )}

                                            {youtube && (
                                                <li className='border-bottom border-black'>
                                                    <a
                                                        className='link-reset block mb3 mt4 type-style-6 hans-purple'
                                                        href={youtube}
                                                        rel='noreferrer noopener'
                                                        target='_blank'>
                                                        YouTube
                                                    </a>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    facebook     : PropTypes.string,
    instagram    : PropTypes.string,
    linkedin     : PropTypes.string,
    mailingListId: PropTypes.string,
    sideTitle    : PropTypes.string,
    title        : PropTypes.string,
    twitter      : PropTypes.string,
    wechat       : PropTypes.string,
    weibo        : PropTypes.string,
    youtube      : PropTypes.string,
};

ContactGlobal.propTypes = propTypes;

export { ContactGlobal };

export default ContactGlobal;
